/* eslint-disable no-nested-ternary */
import { Stack, Tooltip, Typography } from '@mui/material';
import { fLargeNumber } from '../../../../utils/formatNumber';
import { CustomCircularProgress } from '../../../../components/CustomCircularProgress';
import { DynamicTable } from '../../../../components/CustomTable';
import { CustomDialogBox } from '../../../../components/CustomDialogBox';
import useHealthScoreExplain from './useHealthScoreExplain';

function DialogContentElement({ data = [] }) {
  const dataLen = data?.length;

  const CENTER_ALIGN_PROPS = {
    align: 'center',
    headerAlign: 'center',
    headerClassName: 'center-align--header',
  };

  const columns = [
    { field: 'rule', headerName: 'KPI Rule' },
    { field: 'value', headerName: 'Value', ...CENTER_ALIGN_PROPS },
    {
      field: 'threshold',
      headerName: (
        <Stack>
          <Typography fontSize="14px" fontWeight={600}>Threshold</Typography>
          <Typography fontSize="12px" color="text.secondary">(Low - High)</Typography>
        </Stack>
      ),
      ...CENTER_ALIGN_PROPS,
    },
    { field: 'weightage', headerName: 'Weightage', ...CENTER_ALIGN_PROPS },
  ];
  const rows = dataLen && data.map((rule) => ({
    rule: (
      <>
        <Typography>{rule.targetMetric}</Typography>
        <Typography fontSize="15px" color="text.secondary">
          {rule.type === 'Package Engagement'
            ? (rule.package?.trim() ? rule.package : 'All Packages')
            : rule.feature}
        </Typography>
      </>
    ),
    value: (
      <Typography sx={{
        color: 'success.darker',
        backgroundColor: 'success.lighter',
        textAlign: 'center',
        borderRadius: 2,
        px: 1,
      }}
      >
        {fLargeNumber(rule.value)}
      </Typography>
    ),
    threshold:
    (
      <Typography sx={{
        color: 'info.darker',
        backgroundColor: 'info.lighter',
        textAlign: 'center',
        borderRadius: 2,
        px: 1,
      }}
      >
        {`${fLargeNumber(rule.threshold[0])} - ${fLargeNumber(rule.threshold[1])}`}
      </Typography>
    ),
    weightage: <Typography sx={{ textAlign: 'center' }}>{rule.points}</Typography>,
  }));

  return (
    <DynamicTable showHeader columns={columns} rows={rows} dialog />
  );
}

function TitleElement({ label, value }) {
  return (
    <Stack flexDirection="row" alignItems="center" gap={1}>
      <CustomCircularProgress value={value} height={35} width={35} />
      <Tooltip title={label}>
        <Typography fontWeight={700}>{label}</Typography>
      </Tooltip>
    </Stack>
  );
}

function HealthScoreExplain(props) {
  const {
    open, setOpen, isShare, permissions, healthScore,
  } = props;

  const {
    healthScoreDialogData, handleEditHealthScore,
  } = useHealthScoreExplain();

  return (
    <CustomDialogBox
      large
      noPadding
      title={<TitleElement label={healthScoreDialogData?.healthScoreLabel} value={healthScore} />}
      open={open}
      handleClose={setOpen}
      content={<DialogContentElement data={healthScoreDialogData?.healthScoreData} />}
      actions={(permissions.write && !isShare) && { info: healthScoreDialogData?.healthScoreRange, title: 'Edit KPI Score', onClick: () => handleEditHealthScore(healthScoreDialogData.healthScoreId) }}
    />
  );
}

export default HealthScoreExplain;
